/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramBudgetBilling } from './program-budget-billing';
import { ProgramBudgetUsage } from './program-budget-usage';


export interface ProgramBudget { 
    /**
     * The program\'s access mode, as the money sees it. `platform` runs on Convercus\'s models under the flat monthly limit, `dedicated` on the same models with its own optional limit, `byok` on the customer\'s own key. A byok program whose stored key has stopped working reports `platform` here, because that is whose key its turns are running on.
     */
    mode: ProgramBudget.ModeEnum;
    /**
     * Present in platform and dedicated mode. Never present in byok mode.
     */
    budget?: ProgramBudgetUsage;
    /**
     * Present in byok mode when a key is stored — the one line the UI shows where the budget card would otherwise be.
     */
    billing?: ProgramBudgetBilling;
}
export namespace ProgramBudget {
    export type ModeEnum = 'platform' | 'dedicated' | 'byok';
    export const ModeEnum = {
        Platform: 'platform' as ModeEnum,
        Dedicated: 'dedicated' as ModeEnum,
        Byok: 'byok' as ModeEnum
    };
}


